import _ from 'lodash';
import React from 'react';
import {
    FormControl as MuiFormControl,
    FormLabel,
    RadioGroup,
    Radio,
    FormControlLabel
} from '@mui/material';

const RadioButtonControl = ({ field,
    textValuePairs,
    value,
    onChange,
    onBlur,
    className,
    disabled,
    loading,
    'aria-invalid': ariaInvalid,
    'aria-describedby': ariaDescribedBy,
}) => {

    let idLabel = "field_label_" + field.FieldName;
    let textValues = textValuePairs;
    return (
        <MuiFormControl disabled={disabled} error={ariaInvalid}>
            <FormLabel {...(field.IsRequired && { required: true })} id={idLabel}>{field.DisplayName}</FormLabel>
            <RadioGroup
                className={className}
                aria-labelledby={idLabel}
                aria-invalid={ariaInvalid}
                aria-describedby={ariaDescribedBy}
                value={value}
                {...(field.IsRequired && { required: true })}
                name={"radio-buttons-group-" + field.FieldName}
                onChange={(context) => onChange(context, field)}
                onBlur={(context) => onBlur ? onBlur(context, field) : null}
            >
                {_.map(textValues, (x => { return (<FormControlLabel key={"field_" + field.FieldName + "_" + x.Value} value={x.Value} control={<Radio />} label={x.Text} disabled={disabled} />); }))}
            </RadioGroup>
        </MuiFormControl>
    );
}

export default RadioButtonControl;